import { useEffect, useState } from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import {
  LayoutDashboard, Users, Wallet, LandPlot, FolderKanban, ClipboardCheck, Images, UserCog, ScrollText, Settings,
  Sprout, FileText, UserCircle, Menu, LogOut, Receipt, Coffee, AlertTriangle, Inbox, Archive, ListChecks, Bell, HandCoins, Ban, ShieldAlert, UserCheck, Search, Heart, UserPlus,
} from "lucide-react";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "../ui/sheet";
import { Logo } from "../Logo";
import { useAuth } from "../../context/AuthContext";
import { ROLE_LABELS, orgName } from "../../lib/labels";
import { api } from "../../lib/api";

const A = "/dashboard/admin";
const F = "/dashboard/kelompok-tani";
const I = "/dashboard/investor";
const P = "/dashboard/pemilik-lahan";
const M = "/dashboard/pengelola";

export const NAV = {
  SUPER_ADMIN: [
    { to: A, label: "Dashboard", icon: LayoutDashboard, id: "dashboard", end: true },
    { to: `${A}/kelompok-tani`, label: "Kelompok / Koperasi Tani", icon: Users, id: "farmer-groups" },
    { to: `${A}/investor`, label: "Investor", icon: Wallet, id: "investors" },
    { to: `${A}/lahan`, label: "Lahan Kopi", icon: LandPlot, id: "land" },
    { to: `${A}/pemantauan-lahan`, label: "Pemantauan Lahan", icon: LandPlot, id: "land-monitor" },
    { to: `${A}/pengajuan-lahan`, label: "Pengajuan Lahan Baru", icon: Inbox, id: "land-applications" },
    { to: `${A}/pengelola-perorangan`, label: "Pengelola Perorangan", icon: UserCog, id: "individual-managers" },
    { to: `${A}/pengajuan-pengelola`, label: "Pengajuan Pengelola Kebun", icon: UserCheck, id: "manager-requests" },
    { to: `${A}/proyek`, label: "Rencana Kebun & Kebun", icon: FolderKanban, id: "projects" },
    { to: `${A}/bagi-hasil`, label: "Review Skema & Bagi Hasil Kebun", icon: HandCoins, id: "profit" },
    { to: `${A}/rekap-imbalan`, label: "Rekap Imbalan Jasa PT SJI", icon: Receipt, id: "imbalan-recap" },
    { to: `${A}/arsip-pembukuan`, label: "Arsip Data Pembukuan", icon: Archive, id: "bookkeeping" },
    { to: `${A}/asumsi-bagi-hasil`, label: "Parameter Asumsi Bagi Hasil", icon: Receipt, id: "sim-params" },
    { to: `${A}/pengajuan-pemodal`, label: "Pengajuan Pemodal", icon: UserPlus, id: "investor-applications" },
    { to: `${A}/minat-investasi`, label: "Minat Pemodal Kebun", icon: Inbox, id: "interests" },
    { to: `${A}/pemilik-lahan`, label: "Pemilik Lahan", icon: Users, id: "owners" },
    { to: `${A}/legalitas`, label: "Legalitas & Pemantauan Dokumen", icon: FileText, id: "legal" },
    { to: `${A}/persetujuan`, label: "Persetujuan", icon: ClipboardCheck, id: "approvals" },
    { to: `${A}/media`, label: "Media", icon: Images, id: "media" },
    { to: `${A}/arsip-foto`, label: "Arsip Foto Kebun", icon: Archive, id: "photo-archive" },
    { to: `${A}/pengguna`, label: "Pengguna", icon: UserCog, id: "users" },
    { to: `${A}/pengajuan`, label: "Manajemen Pengajuan", icon: ListChecks, id: "submissions" },
    { to: `${A}/notifikasi`, label: "Notifikasi", icon: Bell, id: "notifications" },
    { to: `${A}/daftar-hitam`, label: "Daftar Hitam", icon: Ban, id: "watchlist" },
    { to: `${A}/keamanan`, label: "Pusat Keamanan", icon: ShieldAlert, id: "security" },
    { to: `${A}/audit-log`, label: "Audit Log", icon: ScrollText, id: "audit-log" },
    { to: `${A}/pengaturan`, label: "Pengaturan", icon: Settings, id: "settings" },
    { to: `${A}/profil`, label: "Profil & Kata Sandi", icon: UserCircle, id: "profile" },
  ],
  FARMER_GROUP: [
    { to: F, label: "Dashboard", icon: LayoutDashboard, id: "dashboard", end: true },
    { to: `${F}/investor-proyek`, label: "Pemodal & Kebun", icon: Wallet, id: "investor-projects" },
    { to: `${F}/lahan`, label: "Manajemen Lahan", icon: LandPlot, id: "my-land" },
    { to: `${F}/proyek`, label: "Kebun Saya", icon: FolderKanban, id: "my-projects" },
    { to: `${F}/permintaan-pengelolaan`, label: "Permintaan Pengelolaan", icon: Bell, id: "manager-inbox", badge: true },
    { to: `${F}/kegiatan`, label: "Update Kegiatan Kebun", icon: Sprout, id: "farm-updates" },
    { to: `${F}/biaya`, label: "Biaya & Bukti", icon: Receipt, id: "expenses" },
    { to: `${F}/legalitas`, label: "Legalitas & Dokumen", icon: FileText, id: "legal" },
    { to: `${F}/panen`, label: "Panen & Produksi Kopi", icon: Coffee, id: "harvest" },
    { to: `${F}/bagi-hasil`, label: "Skema & Bagi Hasil Kebun", icon: HandCoins, id: "profit" },
    { to: `${F}/media`, label: "Foto & Video", icon: Images, id: "media" },
    { to: `${F}/arsip-foto`, label: "Arsip Foto Kebun", icon: Archive, id: "photo-archive" },
    { to: `${F}/masalah`, label: "Masalah Kebun", icon: AlertTriangle, id: "issues" },
    { to: `${F}/dokumen`, label: "Dokumen", icon: FileText, id: "documents" },
    { to: `${F}/profil`, label: "Profil", icon: UserCircle, id: "profile" },
  ],
  INVESTOR: [
    { to: `${I}/rencana-kebun`, label: "Temukan Rencana Kebun", icon: Search, id: "rencana-kebun" },
    { to: `${I}/minat-saya`, label: "Minat Saya", icon: Heart, id: "minat-saya" },
    { to: `${I}/proyek`, label: "Kebun Saya", icon: FolderKanban, id: "my-projects" },
    { to: `${I}/bagi-hasil`, label: "Laporan & Bagi Hasil", icon: HandCoins, id: "profit" },
    { to: I, label: "Notifikasi & Ringkasan", icon: Bell, id: "dashboard", end: true, badge: true },
    { to: `${I}/kegiatan`, label: "Update Kebun Kopi", icon: Sprout, id: "farm-updates" },
    { to: `${I}/biaya`, label: "Biaya & Bukti", icon: Receipt, id: "expenses" },
    { to: `${I}/pengelola`, label: "Pilihan Pengelola", icon: UserCheck, id: "investor-managers" },
    { to: `${I}/media`, label: "Foto & Video", icon: Images, id: "media" },
    { to: `${I}/arsip-foto`, label: "Arsip Foto Kebun", icon: Archive, id: "photo-archive" },
    { to: `${I}/dokumen`, label: "Dokumen", icon: FileText, id: "documents" },
    { to: `${I}/profil`, label: "Profil", icon: UserCircle, id: "profile" },
  ],
  PRIVATE_LAND_OWNER: [
    { to: P, label: "Dashboard", icon: LayoutDashboard, id: "dashboard", end: true },
    { to: `${P}/proyek`, label: "Kebun Kopi Saya", icon: FolderKanban, id: "my-projects" },
    { to: `${P}/kegiatan`, label: "Update Kebun Kopi", icon: Sprout, id: "farm-updates" },
    { to: `${P}/biaya`, label: "Biaya & Bukti", icon: Receipt, id: "expenses" },
    { to: `${P}/panen`, label: "Produksi & Panen", icon: Coffee, id: "harvest" },
    { to: `${P}/media`, label: "Foto & Video", icon: Images, id: "media" },
    { to: `${P}/arsip-foto`, label: "Arsip Foto Kebun", icon: Archive, id: "photo-archive" },
    { to: `${P}/dokumen`, label: "Dokumen", icon: FileText, id: "documents" },
    { to: `${P}/profil`, label: "Profil", icon: UserCircle, id: "profile" },
  ],
  INDIVIDUAL_MANAGER: [
    { to: M, label: "Dashboard", icon: LayoutDashboard, id: "dashboard", end: true },
    { to: `${M}/proyek`, label: "Kebun Saya", icon: FolderKanban, id: "my-projects" },
    { to: `${M}/permintaan-pengelolaan`, label: "Permintaan Pengelolaan", icon: Bell, id: "manager-inbox", badge: true },
    { to: `${M}/kegiatan`, label: "Update Kegiatan Kebun", icon: Sprout, id: "farm-updates" },
    { to: `${M}/biaya`, label: "Biaya & Bukti", icon: Receipt, id: "expenses" },
    { to: `${M}/panen`, label: "Panen & Produksi Kopi", icon: Coffee, id: "harvest" },
    { to: `${M}/bagi-hasil`, label: "Skema & Bagi Hasil Kebun", icon: HandCoins, id: "profit" },
    { to: `${M}/media`, label: "Foto & Video", icon: Images, id: "media" },
    { to: `${M}/arsip-foto`, label: "Arsip Foto Kebun", icon: Archive, id: "photo-archive" },
    { to: `${M}/masalah`, label: "Masalah Kebun", icon: AlertTriangle, id: "issues" },
    { to: `${M}/dokumen`, label: "Dokumen Kebun", icon: FileText, id: "documents" },
    { to: `${M}/profil`, label: "Profil", icon: UserCircle, id: "profile" },
  ],
};

const SideNav = ({ role, onNavigate, prefix, badge }) => (
  <nav className="flex flex-col gap-1" data-testid={`${prefix}sidebar-nav`}>
    {NAV[role].map((n) => (
      <NavLink key={n.to} to={n.to} end={n.end} onClick={onNavigate} data-testid={`${prefix}sidenav-${n.id}`}
        className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${isActive ? "bg-white/10 text-white" : "text-emerald-100/75 hover:text-white hover:bg-white/5"}`}>
        <n.icon className="h-4 w-4" /> <span className="flex-1">{n.label}</span>
        {n.badge && badge > 0 && <span className="rounded-full bg-amber-400 px-1.5 text-[11px] font-bold text-emerald-950" data-testid={`${prefix}sidenav-badge-${n.id}`}>{badge}</span>}
      </NavLink>
    ))}
  </nav>
);

const UserBlock = ({ user, onLogout, prefix }) => (
  <div className="border-t border-white/10 pt-4 mt-4">
    <p className="text-sm font-semibold text-white truncate" data-testid={`${prefix}current-user-name`}>{user.name}</p>
    <p className="text-xs text-emerald-200/70 truncate">{user.email}</p>
    <button onClick={onLogout} className="mt-3 w-full flex items-center gap-2 px-3 py-2 rounded-lg text-sm text-emerald-100/80 hover:bg-white/5 hover:text-white transition-colors" data-testid={`${prefix}logout-btn`}>
      <LogOut className="h-4 w-4" /> Keluar
    </button>
  </div>
);

const OrgHeader = ({ org, prefix }) => (
  <div className="mt-6 mb-4 flex items-center gap-3 rounded-xl bg-white/5 p-3" data-testid={`${prefix}org-header`}>
    {org?.logoPhotoUrl || org?.profilePhotoUrl
      ? <img src={`${process.env.REACT_APP_BACKEND_URL}${org.logoPhotoUrl || org.profilePhotoUrl}`} alt="" className="h-10 w-10 rounded-lg object-contain bg-white shrink-0" />
      : <span className="h-10 w-10 rounded-lg bg-emerald-800 grid place-items-center shrink-0"><Coffee className="h-5 w-5 text-emerald-100" /></span>}
    <div className="min-w-0">
      <p className="text-sm font-extrabold uppercase leading-tight text-white break-words" data-testid={`${prefix}org-name`}>{org ? orgName(org) : "..."}</p>
      <p className="text-[10px] text-emerald-100/80">Pengelola Kebun Kopi</p>
      <p className="text-[11px] font-semibold text-amber-300">Kolaborasi dengan PT SJI</p>
      <p className="text-[10px] text-emerald-200/70">Powered by Salimbado Farm</p>
    </div>
  </div>
);

const SidebarBody = ({ user, org, onLogout, onNavigate, prefix = "", badge }) => (
  <div className="flex flex-col h-full bg-emerald-950 px-4 py-6">
    <Logo light to="/" testid={`${prefix}dash-logo`} />
    {user.role === "FARMER_GROUP" ? <OrgHeader org={org} prefix={prefix} /> : (
      <span className="mt-6 mb-4 inline-flex w-fit rounded-full bg-white/10 px-2.5 py-1 text-[11px] font-semibold text-emerald-100" data-testid={`${prefix}role-badge`}>
        {ROLE_LABELS[user.role]}
      </span>
    )}
    <div className="flex-1 overflow-y-auto"><SideNav role={user.role} onNavigate={onNavigate} prefix={prefix} badge={badge} /></div>
    <UserBlock user={user} onLogout={onLogout} prefix={prefix} />
  </div>
);

export default function DashboardLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [org, setOrg] = useState(null);
  useEffect(() => {
    if (user.role !== "FARMER_GROUP" || !user.farmerGroupId) return;
    const load = () => api.get(`/public/farmer-groups/${user.farmerGroupId}`).then((r) => setOrg(r.data))
      .catch(() => api.get("/me/farmer-group").then((r) => setOrg(r.data)).catch(() => {}));
    load();
    window.addEventListener("org-updated", load);
    return () => window.removeEventListener("org-updated", load);
  }, [user.role, user.farmerGroupId]);
  const [badge, setBadge] = useState(0);
  useEffect(() => {
    if (!["FARMER_GROUP", "INDIVIDUAL_MANAGER", "INVESTOR"].includes(user.role)) return;
    const load = () => (user.role === "INVESTOR"
      ? api.get("/my-notifications").then((r) => setBadge(r.data.unread))
      : api.get("/manager-requests/inbox").then((r) => setBadge(Math.max(r.data.pending, r.data.unread)))).catch(() => {});
    load();
    window.addEventListener("manager-inbox-updated", load);
    return () => window.removeEventListener("manager-inbox-updated", load);
  }, [user.role]);
  const onLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };
  return (
    <div className="min-h-screen bg-[#F8FAF6]" data-testid="dashboard-layout">
      <aside className="hidden lg:block fixed inset-y-0 left-0 w-64 z-30"><SidebarBody user={user} org={org} onLogout={onLogout} badge={badge} /></aside>
      <header className="lg:hidden sticky top-0 z-40 bg-emerald-950 min-h-14 px-4 py-2 flex items-center justify-between gap-3">
        {user.role === "FARMER_GROUP" ? (
          <div className="min-w-0 flex items-center gap-2.5" data-testid="mobile-org-header">
            {(org?.logoPhotoUrl || org?.profilePhotoUrl) && <img src={`${process.env.REACT_APP_BACKEND_URL}${org.logoPhotoUrl || org.profilePhotoUrl}`} alt="" className="h-9 w-9 rounded-md object-contain bg-white shrink-0" />}
            <div className="min-w-0">
            <p className="text-sm font-extrabold text-white leading-tight truncate">{org ? orgName(org) : "Salimbado Farm"}</p>
            <p className="text-[11px] font-semibold text-amber-300">Kolaborasi dengan PT SJI</p>
            </div>
          </div>
        ) : <Logo light testid="mobile-dash-logo" />}
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="p-2 rounded-md text-white hover:bg-white/10" aria-label="Menu" data-testid="dash-mobile-menu-btn"><Menu className="h-6 w-6" /></button>
          </SheetTrigger>
          <SheetContent side="left" className="p-0 w-72 border-0 [&>button]:text-white [&>button]:opacity-90">
            <SheetTitle className="sr-only">Menu Dashboard</SheetTitle>
            <SidebarBody user={user} org={org} onLogout={onLogout} onNavigate={() => setOpen(false)} prefix="m-" badge={badge} />
          </SheetContent>
        </Sheet>
      </header>
      <main className="lg:pl-64">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 py-6 sm:py-10"><Outlet /></div>
      </main>
    </div>
  );
}
